import claimantType from './claimantType';
import personalInformation from './personalInformation';
import otherVeteranInformation from './otherVeteranInformation';
import emailAddress from './emailAddress';
import phoneNumber from './phoneNumber';
import dateReceivedBy from './dateReceivedBy';
import incomeNetWorthDateRange from './incomeNetWorthDateRange';
import personalInformationPrefill from './personalInformationPrefill';
import contactInformationPrefill from './contactInformationPrefill';
import { enablePrefillUpdate527ez0969 } from '../../../helpers';
import claimantInformationPrefill from './claimantInformationPrefill';
import claimantInformation from './claimantInformation';

const veteranInformation = enablePrefillUpdate527ez0969()
  ? {
      personalInformation: personalInformationPrefill,
      claimantInformation: claimantInformationPrefill,
      ...contactInformationPrefill,
    }
  : { personalInformation, claimantInformation, emailAddress, phoneNumber };

export default {
  title: 'Veteran and claimant information',
  pages: {
    claimantType,
    ...veteranInformation,
    otherVeteranInformation,
    dateReceivedBy,
    incomeNetWorthDateRange,
  },
};
